export default {
  h7: {
    toDeclare: '待申报',
    declaring: '处理中',
    rejected: '申报错误',
    declared: '已申报',
    accepted: '已受理',
    checking: '查验',
    release: '放行',
    inControl: '查验中',
    status: '状态',
    shippingRef: 'Shipping Ref',
    lateDecl: 'Last Decl',
    trackingNo: 'Tracking No',
    lrn: 'LRN',
    mrn: 'MRN',
    all: '全部',
    reject: '拒绝',
    gotIt: '知道了',
    record: '历史记录',
    shippingReference: '运输参考',
    lrnLabel: 'LRN',
    correlationId: '关联 ID',
    userId: '用户 ID'
  },
  declaration: {
    detail: '详情',
    viewRecord: '查看记录',
    success: '成功',
    trackingNumber: 'Tracking Number:',
    latestDeclarationTime: 'Latest declaration time:',
    basicInfo: '基本信息',
    transportType: '运输类型',
    methodPaymentTaxes: '付款方式',
    transactionType: '交易类型',
    locationOfGoods: '货物所在地',
    deferredPayment: '延期付款',
    customsBrokerInfo: '报关行信息',
    eori: 'EORI',
    name: '名称',
    phoneNumber: '电话号码',
    consigneeInfo: '收货人信息',
    address: '地址',
    consignorInfo: '发货人信息',
    taxRepresentativeInfo: '税务代表信息',
    status: '状态',
    receiverVAT: '收件人增值税',
    documentInfo: '单据信息',
    supportingReferenceNumber: '辅助参考编号',
    supportingType: '辅助类型',
    previousReferenceNumber: '先前参考编号',
    previousType: '先前类型',
    goodsInfo: '货物信息',
    referenceNumberURC: '参考编号 URC',
    totalGrossMass: '总毛重',
    totalValue: '总值',
    serialNumber: '序号',
    hsCode: 'HS 编码',
    descriptionOfGoods: '货物描述',
    intrinsicValue: '内在价值',
    grossMass: '毛重',
    supplementaryUnits: '补充单位',
    quantity: '数量',
    back: '返回',
    email: '邮箱'
  },
  batch: {
    importData: '导入数据',
    consignee: '委托方',
    hsQty: 'HS 编码数量',
    parcelQty: '包裹数量',
    toDeclare: '待申报',
    inProcess: '处理中',
    sent: '已发送',
    release: '放行',
    inControl: '查验中',
    rejected: '已拒绝',
    actions: '操作',
    declare: '申报',
    delete: '删除',
    exportErrors: '导出错误',
    statusReport: '状态报告',
    downloadManifest: '下载清单',
    importErrors: '导入错误',
    confirm: '确定',
    cancel: '取消',
    areYouSureToDeclare: '确定要申报吗？',
    areYouSureToDelete: '确定要删除吗？',
    declareSuccessful: '申报成功',
    deleteSuccessful: '删除成功',
    clickToUpload: '点击上传文件或拖拽文件到这里',
    downloadTemplate: '下载导入模板',
    gotIt: '知道了',
    systemProcessing: '系统正在处理数据...',
    waitUploadComplete: '请等待上传完成。',
    closeIfUrgent: '如果您有其他紧急任务需要处理，可以关闭此弹窗。',
    checkDocumentCenter: '您可以在文档中心查看导入结果。',
    uploadSuccessful: '上传成功',
    uploadFailed: '上传失败',
    verificationFailed: '注意：数据验证失败。',
    clickDownloadOrShift: '点击此处',
    orShiftToImportTask: '或切换到右上角的导入任务，下载带有错误信息的文件。',
    checkErrorMessage: '检查结果文件最后一列的错误信息，并修改您准备再次上传的原始模板中的数据。',
    reuploadAfterCorrect: '在所有错误被更正或删除后重新上传。'
  },
  taskPane: {
    success: '成功',
    failure: '失败',
    loading: '加载中...',
    noMore: '没有更多数据了'
  },
  user: {
    userName: '用户名',
    createTime: '创建时间',
    email: '邮箱',
    userRole: '用户角色',
    status: '状态',
    activated: '已激活',
    disabled: '已禁用',
    actions: '操作',
    role: '角色',
    add: '添加',
    save: '保存',
    total: '共',
    items: '条',
    pleaseEnterUserName: '请输入用户名',
    pleaseEnterEmail: '请输入邮箱',
    pleaseEnterCorrectEmail: '请输入正确的邮箱格式',
    addUser: '添加用户',
    updateUser: '更新用户'
  },
  role: {
    roleName: '角色名称',
    roleNumber: '角色编号',
    createTime: '创建时间',
    status: '状态',
    activated: '已激活',
    disabled: '已禁用',
    roleDescription: '角色描述',
    actions: '操作',
    add: '添加',
    total: '共',
    items: '条',
    roleInformation: '角色信息',
    functionalDescription: '功能说明',
    save: '保存',
    back: '返回',
    pleaseEnter: '请输入'
  },
  login: {
    welcome: '欢迎访问',
    platform: 'e-star 清关平台',
    enterDetails: '请输入您的详细信息',
    email: '邮箱',
    password: '密码',
    forgotPassword: '忘记密码',
    signIn: '登录',
    register: '注册',
    orConnectWith: '或使用以下方式连接',
    capsLockOn: '大写锁定已开启',
    usernameRequired: '请输入正确的用户名',
    passwordTooShort: '密码不能少于 6 位'
  },
  register: {
    register: '注册',
    welcomeRegister: '欢迎注册您的 e-Clearance 账户',
    email: '邮箱',
    pleaseEnterEmail: '请输入邮箱',
    verificationCode: '验证码',
    pleaseEnterCode: '请输入邮箱验证码',
    send: '发送',
    password: '密码',
    pleaseEnterPassword: '请输入密码',
    confirmPassword: '确认密码',
    pleaseEnterPasswordAgain: '请再次输入密码',
    signIn: '注册',
    emailRequired: '请输入邮箱',
    emailInvalid: '请输入正确的邮箱格式',
    passwordRequired: '请输入密码',
    passwordTooShort: '密码不能少于 6 位',
    confirmPasswordRequired: '请再次输入密码',
    passwordsMismatch: '两次输入的密码不一致！',
    enterEmailFirst: '请先输入邮箱',
    verificationSent: '验证码发送成功',
    verificationFailed: '验证码发送失败'
  },
  forgot: {
    welcomeReset: '欢迎重置您的密码',
    email: '邮箱',
    pleaseEnterEmail: '请输入邮箱',
    verificationCode: '验证码',
    pleaseEnterCode: '请输入邮箱验证码',
    send: '发送',
    password: '密码',
    pleaseEnterPassword: '请输入密码',
    newPassword: '新密码',
    pleaseEnterNewPassword: '请输入新密码',
    resetPassword: '重置密码',
    emailRequired: '请输入邮箱',
    emailInvalid: '请输入正确的邮箱格式',
    passwordRequired: '请输入密码',
    passwordTooShort: '密码不能少于 6 位',
    newPasswordRequired: '请输入新密码',
    passwordsMismatch: '两次输入的密码不一致！',
    enterEmailFirst: '请先输入邮箱',
    verificationSent: '验证码发送成功',
    verificationFailed: '验证码发送失败'
  },
  navbar: {
    changePassword: '修改密码',
    logout: '退出登录',
    oldPassword: '旧密码',
    newPassword: '新密码',
    confirmNewPassword: '确认新密码',
    pleaseEnterOldPassword: '请输入旧密码',
    pleaseEnterNewPassword: '请输入新密码',
    pleaseConfirmNewPassword: '请确认新密码',
    save: '保存',
    cancel: '取消',
    passwordRequired: '请输入密码',
    newPasswordRequired: '请输入新密码',
    confirmPasswordRequired: '请确认密码',
    passwordTooShort: '密码不能少于 6 位',
    passwordsMismatch: '两次输入的密码不一致',
    changePasswordSuccess: '密码修改成功',
    changePasswordFailed: '密码修改失败'
  },
  global: {
    enter: '请输入',
    query: '查询',
    reset: '重置',
    add: '新增',
    total: '共',
    item: '条',
    action: '操作',
    status: '状态',
    startDate: '开始时间',
    endDate: '结束时间'
  },
  enterprise: {
    companyNameLabel: '公司名称',
    statusLabel: '备案状态',
    submissionTimeLabel: '提交时间',
    companyName: '公司名称',
    contactName: '联系人姓名',
    globalVatNo: '全球增值税号',
    eori: 'EORI',
    submissionTime: '提交时间',
    reviewTime: '审核时间',
    approve: '通过',
    reject: '拒绝',
    confirmApprove: '您确定要通过吗？',
    rejectionsReason: '拒绝原因',
    inputReason: '请输入原因',
    submitSuccess: '提交成功！',
    pendingStatus: '待备案',
    submittedStatus: '已提交',
    approvedStatus: '已通过',
    rejectedStatus: '已拒绝',
    verificationRequired: '请先完成公司信息验证，审核通过后方可访问。',
    rejectedTip: '企业备案审核未通过，原因：{remark}。请修改信息后重新提交。',
    submittedTip: '企业备案已提交，正在审核中，请耐心等待。',
    approvedTip: '企业备案审核通过，可正常使用系统全部功能。',
    companyInfo: '公司信息',
    companyAddress: '公司地址',
    incorporationDate: '注册日期',
    contactInfo: '联系信息',
    email: '邮箱',
    phoneNumber: '电话号码',
    taxInfo: '税务信息',
    remarks: '备注',
    paymentInfo: '支付信息',
    paymentType: '支付类型',
    paymentMethodA: 'A',
    paymentMethodE: 'E',
    paymentMethodP: 'P',
    paymentMethodBankTransfer: '银行转账',
    paymentMethodCreditCard: '信用卡',
    paymentMethodSepa: 'SEPA',
    pleaseSelect: '请选择',
    paymentRefNumber: '支付参考号',
    defaultFlag: '默认标志',
    add: '+ 添加',
    delete: '删除',
    edit: '编辑',
    cancel: '取消',
    locationInfo: '地点信息',
    locationName: '地点名称',
    locationCode: '地点代码',
    submit: '提交',
    emailCorrect: '请输入正确的邮箱格式',
    submitSuccessful: '提交成功',
    submitFailed: '提交失败',
    submitFailedMsg: '提交失败：',
    unknownError: '未知错误',
    completeFields: '请填写所有必填字段',
    paymentTypeRow: '请选择第',
    paymentRefRow: '请输入第',
    oneDefaultRequired: '至少需要设置一种支付方式为默认',
    locationNameRow: '请输入第',
    locationCodeRow: '请输入第'
  },
  menu: {
    menuList: '菜单列表',
    addMenu: '新增菜单',
    menuEdit: '菜单编辑',
    menuName: '菜单名称',
    pleaseEnterMenuName: '请输入菜单名称',
    languageKey: '多语言名称',
    pleaseEnterMultiLanguageFormat: '请输入如下格式，例如：$tr("submit", "提交")',
    menuType: '菜单类型',
    directory: '目录',
    menu: '菜单',
    permission: '权限点',
    portal: 'Portal',
    routePath: '路由地址',
    pleaseEnterRoutePath: '请输入菜单路径',
    pleaseEnterPermission: '请输入权限标识',
    parentMenu: '上级菜单',
    pleaseSelectParentMenu: '请选择上级菜单',
    none: '无',
    displayOrder: '显示排序',
    pleaseEnterOrderNumber: '请输入排序号',
    menuIcon: '菜单图标',
    pleaseEnterMenuIcon: '请输入菜单图标',
    visible: '是否显示',
    show: '显示',
    hide: '隐藏',
    save: '保存',
    cancel: '取消',
    delete: '删除',
    pleaseSelectMenuToEdit: '请选择左侧菜单进行编辑',
    createMenu: '新建菜单',
    confirm: '确定',
    pleaseEnterUserName: '请输入用户名',
    pleaseSelectMenuType: '请选择菜单类型',
    pleaseSelectParentMenuFirst: '权限点必须选择上级菜单',
    updateSuccess: '修改成功',
    confirmDelete: '确定要删除该菜单？',
    prompt: '提示',
    deleteSuccess: '删除成功',
    addSuccess: '添加成功'
  }
}
